import * as UI from "@iyk/ui"
import { Data } from "effect"

const make = Data.case<Config>()

export const config = make({
  appId: "cmat",
  general: {
    email: "cmat@iyk.app",
    name: "CMAT",
    baseUrl: "https://cmat.iyk.app",
    shopUrl: "https://cmat.terrible.group/",
  },
  meta: {
    description: "CMAT",
  },
  social: [
    {
      label: "Instagram",
      logo: UI.Icon.Instagram,
      href: "https://instagram.com/cmatbaby",
    },
    {
      label: "TikTok",
      logo: UI.Icon.Tiktok,
      href: "https://tiktok.com/@cmatbaby",
    },
    {
      label: "YouTube",
      logo: UI.Icon.Youtube,
      href: "https://www.youtube.com/@CMATbaby",
    },
    {
      label: "Spotify",
      logo: UI.Icon.Spotify,
      href: "https://open.spotify.com/playlist/5Ru6BBf3GLMNBO8hNN85sB?si=8fffed260e364366",
    },
    {
      label: "Apple Music",
      logo: UI.Icon.AppleMusic,
      href: "https://music.apple.com/gb/artist/cmat/1506697965",
    },
    {
      label: "X",
      logo: UI.Icon.X,
      href: "https://x.com/cmatbaby",
    },
  ],
})

interface Config {
  appId: string
  general: {
    email: string
    name: string
    baseUrl: string
    shopUrl: string
  }
  meta: {
    description: string
  }
  social: Array<{
    label: string
    logo: React.ElementType
    href: string
  }>
}
